import React from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import InventoryReceivedTable from './InventoryReceivedTable';
import InventoryReceivedPaginator from './InventoryReceivedPaginator';

const InventoryReceived = () => {
    return (
        <TabPageContainer>
            <InventoryReceivedTable />
            <InventoryReceivedPaginator />
        </TabPageContainer>
    );
};

export default InventoryReceived;
